'use client';

import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { Link } from '@lib/navigation';

export default function LoginLink() {
  const params = useSearchParams();
  const t = useTranslations('auth');

  const getLoginLink = () => {
    if (params ? params.has('from') : false) {
      return `/login?from=${params ? params.get('from') : ''}`;
    }
    return '/login';
  };

  return (
    <div className="px-6 py-1 text-center text-white lg:py-6">
      <h2 className="mb-4 text-lg font-bold lg:mb-3 lg:text-xl">{t('register.registeredAlready')}</h2>
      <div className="my-4 flex items-center justify-center">
        <Link
          href={getLoginLink()}
          rel="nofollow"
          className="block h-[42px] max-w-96 rounded-3xl border border-gray-900 bg-white px-4 py-2 text-center text-sm text-gray-900 transition-colors hover:bg-premium-900 hover:text-white"
        >
          {t('register.logIn')}
        </Link>
      </div>
    </div>
  );
}
